/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const RatePlanList = MatxLoadable({
  loader: () => import("../views/rates"),
});

const RatePlanDetail = MatxLoadable({
  loader: () => import("../views/rates/ratePlanDetail"),
});

const rateRoutes = [
  {
    path: "/rates/:id",
    component: RatePlanDetail,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/rates",
    component: RatePlanList,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default rateRoutes;
